import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import ApiService from 'services/ApiService';

import { Style, Stroke } from 'ol/style.js';
import { ToFeatures } from 'services/GeoJsonService';

import { setSourceForGeoJSON } from '../OlExtension';

export default class LayerSafeSelfLink extends VectorLayer {

    constructor(map) {
        super({
            name: 'selfLinkLayer',
            source: new VectorSource(),
            style: (feature) => this.getDefaultStyle(feature),
            userLayer: true,
            layerIndex: 4,
        });
        this.map = map;
        this.map?.addLayer(this);
        this.setData();
    }

    setData = function () {
        const layer = this;
        ApiService.get("newdashboard/gis/GetSelfDrivingLink").then(response => {
            if (response.status === 200) {
                const data = response.data;
                setSourceForGeoJSON(layer, data)
            }
        })
        ApiService.get("newdashboard/gis/GetSelfDrivingNode").then(response => {
            if (response.status === 200) {
                const data = response.data;
            }
        })
    }

    getDefaultStyle = (feature) => {
        return new Style({
            stroke: new Stroke({
                color: '#f5822f',
                lineCap: "round", // butt, round, square
                lineJoin: "round", // bevel, round, miter
                lineDash: null,
                lineDashOffset: 0,
                miterLimit: 10,
                width: 8,
            }),
            zIndex: 1
        })
    };
}